export default "__VITE_ASSET__DaBtbbHi__"